import api from "./axios";

export const getKnowledgeBaseApi = () => api.get("/knowledge-base");
export const updateKnowledgeBaseApi = (data) => api.put("/knowledge-base", data);
